module.exports = __webpack_public_path__ + "img/sy.e8fe6425.jpg";